import { createStyles } from "@mantine/core";

export const useStyles = createStyles(() => ({
  tooltipLink: {
    borderBottom: "1px dashed",
    cursor: "pointer",
  },
}));
